// Shared Squadverse UI Theme — Single source of truth
const theme = {
  colors: {
    background: {
      base: '#0F172A',
      section: '#1E293B',
      card: '#32405a',
      header: '#1E3A8A',
      accent: '#3B82F6',
      toolbarBg: 'rgba(30,41,59,0.95)',
    },
    text: {
      heading: '#FFFFFF',
      headingAccent: '#3B82F6',
      primary: '#E2E8F0',
      muted: '#94A3B8',
      inverted: '#0F172A',
    },
    interactive: {
      primary: '#3B82F6',
      primaryHover: '#2563EB',
      secondary: '#38BDF8',
      success: '#16A34A',
      successHover: '#15803D',
      danger: '#EF4444',
      dangerHover: '#DC2626',
      warning: '#FACC15',
    },
    border: {
      default: '#334155',
      focus: '#3B82F6',
    },
    shadow: {
      default: 'rgba(0, 0, 0, 0.2)',
      soft: 'rgba(59, 130, 246, 0.2)',
      card: '0 4px 20px rgba(0, 0, 0, 0.15)',
      button: '0 2px 8px rgba(59, 130, 246, 0.3)',
    },
    state: {
      warning: '#FACC15',
      info: '#0EA5E9',
      neutral: '#64748B',
    },
    tactics: {
      arrow: '#FACC15',
      note: '#38BDF8',
      playerFill: '#fff',
      playerStroke: '#3B82F6',
    },
  },
  radii: {
    card: '12px',
    button: '8px',
    input: '6px',
    note: '4px',
  },
  spacing: {
    section: '2rem',
    cardPadding: '1.5rem',
    inputPadding: '0.75rem 1rem',
    toolbarGap: '8px',
    buttonPadding: '8px 12px',
  },
};

export default theme;
